export const nlSocialMedia = {
  title: "Social Media Marketing Diensten",
  description: "Strategische social media oplossingen om uw merk te laten groeien, uw publiek te betrekken en meetbare resultaten te behalen op alle platforms.",
  subtitle: "Social Media Marketing Oplossingen",

  servicesTitle: "Onze Social Media Diensten",
  servicesSubtitle: "Uitgebreide strategieën afgestemd op de unieke stem van uw merk",
  services: {
    strategy: {
      title: "Social Media Strategie",
      description: "Aangepaste plannen om uw bedrijfsdoelen te bereiken via sociale platforms.",
      technologies: ["Platformselectie", "Contentplanning", "Publieksanalyse", "Concurrentieonderzoek", "KPI Instellen"]
    },
    content: {
      title: "Contentcreatie",
      description: "Opvallende, platform-geoptimaliseerde content die het verhaal van uw merk vertelt.",
      technologies: ["Grafisch Ontwerp", "Videoproductie", "Copywriting", "Fotografie", "Contentkalenders"]
    },
    advertising: {
      title: "Social Media Advertising",
      description: "Gerichte betaalde campagnes om uw ideale klanten te bereiken.",
      technologies: ["Facebook Ads", "Instagram Ads", "LinkedIn Ads", "Twitter Ads", "TikTok Ads"]
    },
    management: {
      title: "Accountbeheer",
      description: "Dagelijks beheer en community engagement op uw social media profielen.",
      technologies: ["Postplanning", "Community Management", "Merkmonitoring", "Responsstrategie", "Crisismanagement"]
    },
    analytics: {
      title: "Prestatieanalyse",
      description: "Data-gedreven inzichten om uw social media prestaties te meten en te optimaliseren.",
      technologies: ["ROI Tracking", "Engagement Metrics", "Publieksgroei", "Concurrentiebenchmarking", "Rapportage"]
    },
    influencer: {
      title: "Influencer Marketing",
      description: "Authentieke samenwerkingen met influencers om uw bereik te vergroten.",
      technologies: ["Influencer Identificatie", "Campagnebeheer", "Relatieopbouw", "Prestatie Tracking", "Compliance"]
    }
  },

  processTitle: "Ons Social Media Proces",
  processSteps: [
    {
      title: "Ontdekking & Onderzoek",
      description: "Uw merk, publiek en concurrentielandschap begrijpen."
    },
    {
      title: "Strategieontwikkeling",
      description: "Aangepaste social media strategieën creëren voor uw bedrijfsdoelen."
    },
    {
      title: "Contentcreatie",
      description: "Ontwikkelen van boeiende, platform-specifieke content voor uw publiek."
    },
    {
      title: "Implementatie",
      description: "Campagnes uitvoeren en dagelijkse social media activiteiten beheren."
    },
    {
      title: "Community Engagement",
      description: "Relaties opbouwen en interactie met uw publiek."
    },
    {
      title: "Analyse & Optimalisatie",
      description: "Prestaties meten en strategieën verfijnen voor betere resultaten."
    }
  ]
};

export const deSocialMedia = {
  title: "Social Media Marketing Dienstleistungen",
  description: "Strategische Social Media Lösungen, um Ihre Marke zu stärken, Ihr Publikum zu begeistern und messbare Ergebnisse auf allen Plattformen zu erzielen.",
  subtitle: "Social Media Marketing Lösungen",

  servicesTitle: "Unsere Social Media Dienstleistungen",
  servicesSubtitle: "Umfassende Strategien, abgestimmt auf die einzigartige Stimme Ihrer Marke",
  services: {
    strategy: {
      title: "Social Media Strategie",
      description: "Individuelle Pläne zur Erreichung Ihrer Geschäftsziele über soziale Plattformen.",
      technologies: ["Plattformwahl", "Contentplanung", "Zielgruppenanalyse", "Wettbewerbsforschung", "KPI-Definition"]
    },
    content: {
      title: "Content-Erstellung",
      description: "Auffällige, plattformoptimierte Inhalte, die die Geschichte Ihrer Marke erzählen.",
      technologies: ["Grafikdesign", "Videoproduktion", "Texterstellung", "Fotografie", "Content-Kalender"]
    },
    advertising: {
      title: "Social Media Werbung",
      description: "Gezielte bezahlte Kampagnen, um Ihre Wunschkunden zu erreichen.",
      technologies: ["Facebook Ads", "Instagram Ads", "LinkedIn Ads", "Twitter Ads", "TikTok Ads"]
    },
    management: {
      title: "Account-Management",
      description: "Tägliche Verwaltung und Community-Engagement auf Ihren Social Media Profilen.",
      technologies: ["Post-Planung", "Community Management", "Markenüberwachung", "Reaktionsstrategie", "Krisenmanagement"]
    },
    analytics: {
      title: "Leistungsanalyse",
      description: "Datenbasierte Einblicke zur Messung und Optimierung Ihrer Social Media Performance.",
      technologies: ["ROI-Tracking", "Engagement-Metriken", "Zielgruppenwachstum", "Wettbewerbsbenchmarking", "Reporting"]
    },
    influencer: {
      title: "Influencer Marketing",
      description: "Authentische Partnerschaften mit Influencern zur Erweiterung Ihrer Reichweite.",
      technologies: ["Influencer Identifikation", "Kampagnenmanagement", "Beziehungsaufbau", "Leistungstracking", "Compliance"]
    }
  },

  processTitle: "Unser Social Media Prozess",
  processSteps: [
    {
      title: "Entdeckung & Recherche",
      description: "Ihre Marke, Ihr Publikum und das Wettbewerbsumfeld verstehen."
    },
    {
      title: "Strategieentwicklung",
      description: "Individuelle Social Media Strategien für Ihre Geschäftsziele entwickeln."
    },
    {
      title: "Content-Erstellung",
      description: "Entwicklung von ansprechenden, plattformspezifischen Inhalten für Ihr Publikum."
    },
    {
      title: "Implementierung",
      description: "Kampagnen durchführen und tägliche Social Media Aktivitäten verwalten."
    },
    {
      title: "Community Engagement",
      description: "Beziehungen aufbauen und mit Ihrem Publikum interagieren."
    },
    {
      title: "Analyse & Optimierung",
      description: "Leistung messen und Strategien für bessere Ergebnisse optimieren."
    }
  ]
};
export const enSocialMedia = {
  // Hero Section
  title: "Social Media Marketing Services",
  description: "Strategic social media solutions to grow your brand, engage your audience, and drive measurable results across all platforms.",
  subtitle: "Social Media Marketing Solutions",

  // Services Section
  servicesTitle: "Our Social Media Services",
  servicesSubtitle: "Comprehensive strategies tailored to your brand's unique voice",
  services: {
    strategy: {
      title: "Social Media Strategy",
      description: "Customized plans to achieve your business objectives through social platforms.",
      technologies: ["Platform Selection", "Content Planning", "Audience Analysis", "Competitive Research", "KPI Setting"]
    },
    content: {
      title: "Content Creation",
      description: "Eye-catching, platform-optimized content that tells your brand story.",
      technologies: ["Graphic Design", "Video Production", "Copywriting", "Photography", "Content Calendars"]
    },
    advertising: {
      title: "Social Media Advertising",
      description: "Targeted paid campaigns to reach your ideal customers.",
      technologies: ["Facebook Ads", "Instagram Ads", "LinkedIn Ads", "Twitter Ads", "TikTok Ads"]
    },
    management: {
      title: "Account Management",
      description: "Daily management and community engagement across your social profiles.",
      technologies: ["Post Scheduling", "Community Management", "Brand Monitoring", "Response Strategy", "Crisis Management"]
    },
    analytics: {
      title: "Performance Analytics",
      description: "Data-driven insights to measure and optimize your social performance.",
      technologies: ["ROI Tracking", "Engagement Metrics", "Audience Growth", "Competitor Benchmarking", "Reporting"]
    },
    influencer: {
      title: "Influencer Marketing",
      description: "Authentic partnerships with influencers to expand your reach.",
      technologies: ["Influencer Identification", "Campaign Management", "Relationship Building", "Performance Tracking", "Compliance"]
    }
  },

  // Process Section
  processTitle: "Our Social Media Process",
  processSteps: [
    {
      title: "Discovery & Research",
      description: "Understand your brand, audience, and competitive landscape."
    },
    {
      title: "Strategy Development",
      description: "Create customized social media strategies for your business goals."
    },
    {
      title: "Content Creation",
      description: "Develop engaging, platform-specific content for your audience."
    },
    {
      title: "Implementation",
      description: "Execute campaigns and manage day-to-day social activities."
    },
    {
      title: "Community Engagement",
      description: "Build relationships and interact with your audience."
    },
    {
      title: "Analysis & Optimization",
      description: "Measure performance and refine strategies for better results."
    }
  ]
};


export const frSocialMedia = {
  title: "Services de Marketing sur les Réseaux Sociaux",
  description: "Solutions stratégiques sur les réseaux sociaux pour développer votre marque, engager votre audience et générer des résultats mesurables sur toutes les plateformes.",
  subtitle: "Solutions de Marketing sur les Réseaux Sociaux",

  servicesTitle: "Nos Services de Réseaux Sociaux",
  servicesSubtitle: "Stratégies complètes adaptées à la voix unique de votre marque",
  services: {
    strategy: {
      title: "Stratégie sur les Réseaux Sociaux",
      description: "Plans personnalisés pour atteindre vos objectifs commerciaux via les plateformes sociales.",
      technologies: ["Sélection de Plateforme", "Planification de Contenu", "Analyse d'Audience", "Recherche Concurrentielle", "Définition des KPI"]
    },
    content: {
      title: "Création de Contenu",
      description: "Contenu accrocheur et optimisé pour chaque plateforme qui raconte l'histoire de votre marque.",
      technologies: ["Design Graphique", "Production Vidéo", "Rédaction", "Photographie", "Calendriers de Contenu"]
    },
    advertising: {
      title: "Publicité sur les Réseaux Sociaux",
      description: "Campagnes payantes ciblées pour atteindre vos clients idéaux.",
      technologies: ["Publicités Facebook", "Publicités Instagram", "Publicités LinkedIn", "Publicités Twitter", "Publicités TikTok"]
    },
    management: {
      title: "Gestion de Compte",
      description: "Gestion quotidienne et engagement communautaire sur vos profils sociaux.",
      technologies: ["Planification de Publications", "Gestion de Communauté", "Surveillance de Marque", "Stratégie de Réponse", "Gestion de Crise"]
    },
    analytics: {
      title: "Analyse de Performance",
      description: "Informations basées sur les données pour mesurer et optimiser votre performance sociale.",
      technologies: ["Suivi du ROI", "Métriques d'Engagement", "Croissance d'Audience", "Analyse Concurrentielle", "Rapports"]
    },
    influencer: {
      title: "Marketing d'Influence",
      description: "Partenariats authentiques avec des influenceurs pour étendre votre portée.",
      technologies: ["Identification d'Influenceurs", "Gestion de Campagne", "Construction de Relations", "Suivi de Performance", "Conformité"]
    }
  },

  processTitle: "Notre Processus sur les Réseaux Sociaux",
  processSteps: [
    {
      title: "Découverte & Recherche",
      description: "Comprendre votre marque, votre audience et votre paysage concurrentiel."
    },
    {
      title: "Développement de Stratégie",
      description: "Créer des stratégies de réseaux sociaux personnalisées pour vos objectifs commerciaux."
    },
    {
      title: "Création de Contenu",
      description: "Développer un contenu engageant et spécifique à chaque plateforme pour votre audience."
    },
    {
      title: "Mise en Œuvre",
      description: "Exécuter des campagnes et gérer les activités sociales quotidiennes."
    },
    {
      title: "Engagement Communautaire",
      description: "Établir des relations et interagir avec votre audience."
    },
    {
      title: "Analyse & Optimisation",
      description: "Mesurer la performance et affiner les stratégies pour de meilleurs résultats."
    }
  ]
};